import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  usePostIssueProformaInvoiceMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { ProformaInvoicesDetailContent } from '../../ProformaInvoices/ProformaInvoicesDetail/ProformaInvoicesDetailContent'

export const IssuedProformaInvoiceEntryList = (props: any) => {
  const {
    userList,
    filteredList,
    getARIssueProformaInvoiceListingLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
    setErrMessage,
    setErrDialog,
    postIDs,
    setPostIDs,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID, ScheduledBillingSubmenu }: any = useParams()
  const companyStatus = localStorage?.getItem('companyStatus')

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteAA, setDeleteAA] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const isSalesOrder = !!(ScheduledBillingSubmenu === 'sales-order')
  const [isCombined, setIsCombined] = useState(false)

  const handleCheckboxChange = event => {
    setIsCombined(event.target.checked)
  }
  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  // handle checkbox for all employee
  const handleSelectAll = e => {
    let temp = postIDs
    if (e.target.checked) {
      filteredList.map(v => {
        temp.add(v?.ProformaRequisitionID)
      })
    } else {
      temp.clear()
    }
    setPostIDs(new Set(temp))
  }

  // handle checkbox for specific entityCoa
  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs
    if (!temp.has(postID)) {
      temp.add(postID)
    } else {
      temp.delete(postID)
    }

    setPostIDs(new Set(temp))
  }

  let listPostIDs: any = Array.from(postIDs || [])

  let checkedData = []
  listPostIDs.map(ID => {
    filteredList.map((el, i) => {
      if (el?.ProformaRequisitionID === ID) {
        checkedData.push(...el?.ProformaRequisitionID)
      }
    })
  })

  const [
    postIssueProformaInvoice,
    { loading: postIssueProformaInvoiceLoading },
  ] = usePostIssueProformaInvoiceMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrorDia(true)
    },
    onCompleted: data => {
      setSnackBarMsg(SystemMsgs.updateRecord())
      setOpenSnackBar(true)
      setOriginalListing([])
      setPostIDs(new Set())
      fetchMore({
        variables: {
          CompanyID: CompanyID,
          isIssued: false,
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const onSubmit = listPostIDs => {
    postIssueProformaInvoice({
      variables: {
        ProformaRequisitionIDs: listPostIDs,
        isIssue: true,
        CompanyID: CompanyID,
      },
    })
  }
  /* -------------------------------------------- */
  /*                     VARIABLE                 */
  /* -------------------------------------------- */
  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {getARIssueProformaInvoiceListingLoading && <Loading />}
      {postIssueProformaInvoiceLoading && <Loading />}
      <ContentWrapper advSearch float>
        {listStatus === 'PENDING' && filteredList?.length !== 0 ? (
          <div
            className="mdDesc flex-space"
            style={{
              paddingLeft: '7px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>
              <Checkbox
                onChange={handleSelectAll}
                color="primary"
                value={''}
                checked={postIDs?.size === filteredList?.length}
                style={{ marginLeft: '-5px', marginTop: '-5px' }}
                disabled={companyStatus === 'INACTIVE'}
              />
              <span style={{ marginLeft: '9px' }}>Select All</span>
            </span>
          </div>
        ) : null}
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    isIssued: listStatus === 'PENDING' ? false : true,
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                getARIssueProformaInvoiceListingLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                if (listStatus === 'PENDING') {
                  return (
                    <CardExpansion
                      summary={
                        <ListItem key={index}>
                          <FormControl
                            component="fieldset"
                            style={{ width: '16px', paddingRight: '16px' }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={el?.ProformaRequisitionID}
                                  onChange={e => {
                                    handleCheckBoxChange(
                                      e,
                                      el?.ProformaRequisitionID,
                                      index
                                    )
                                  }}
                                  onClick={e => e.stopPropagation()}
                                  checked={postIDs?.has(
                                    el?.ProformaRequisitionID
                                  )}
                                  color="primary"
                                  style={{
                                    marginLeft: '10px',
                                    marginRight: '-5px',
                                  }}
                                  disabled={
                                    companyStatus === 'INACTIVE' ? true : false
                                  }
                                />
                              }
                              label=""
                              name="check"
                            />
                          </FormControl>

                          <ListItemText
                            style={{ marginLeft: '25px' }}
                            primary={
                              <>
                                <span className={`xsTitle flex-space`}>
                                  {el?.DebtorName}
                                </span>
                                <span
                                  className="desc"
                                  style={{ justifyContent: 'end' }}
                                >
                                  {`${formatDate(el?.TransactionDate)}`}
                                </span>
                              </>
                            }
                            secondary={
                              <Grid
                                container
                                className="desc flex-space text-noflow"
                              >
                                <Grid
                                  spacing={1}
                                  container
                                  className="table-content"
                                >
                                  <Grid item xs={9}>
                                    <span style={{ fontSize: '10px' }}>
                                      {el?.Name}
                                    </span>
                                  </Grid>
                                  <Grid item xs={3}>
                                    <IconText
                                      parentStyle={{ justifyContent: 'end' }}
                                      font="xxTitle c-orange"
                                      children={amtStr(el?.DocAmt)}
                                    />
                                  </Grid>
                                </Grid>

                                <Grid
                                  spacing={1}
                                  container
                                  className="table-content"
                                >
                                  <Grid item xs={12}>
                                    <div className="icon-text">
                                      <Tooltip
                                        disableFocusListener
                                        title={
                                          <Fragment>
                                            <Grid
                                              container
                                              wrap="nowrap"
                                              spacing={2}
                                            >
                                              <Grid item>
                                                <IconText
                                                  icon={
                                                    <img
                                                      src={SubmitterLog}
                                                      style={{
                                                        width: '12px',
                                                        marginRight: '3px',
                                                      }}
                                                    />
                                                  }
                                                  font="desc"
                                                />
                                              </Grid>
                                              <Grid item xs zeroMinWidth>
                                                <div
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {
                                                    userList?.find(
                                                      x =>
                                                        x?.ID === el?.approvedBy
                                                    )?.name
                                                  }
                                                </div>
                                                <div
                                                  style={{ fontSize: '10px' }}
                                                >
                                                  {formatDate(el?.approvedTs)}{' '}
                                                  &nbsp;
                                                  {formatTime(el?.approvedTs)}
                                                </div>
                                              </Grid>
                                            </Grid>
                                          </Fragment>
                                        }
                                        arrow
                                        enterTouchDelay={0}
                                      >
                                        <div>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </div>
                                      </Tooltip>

                                      <span
                                        className="desc text-noflow"
                                        style={{ display: 'contents' }}
                                      >
                                        {el?.Description}
                                      </span>
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                          />
                        </ListItem>
                      }
                    >
                      {
                        <>
                          <ProformaInvoicesDetailContent
                            listEl={el}
                            listStatus={'COMPLETED'}
                            userList={userList}
                            mode={'expansion'}
                          />
                        </>
                      }
                    </CardExpansion>
                  )
                } else {
                  return (
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            {/* <span className="desc">
                              {formatDate(el?.InvoiceDate)}
                            </span>
                            &nbsp;&nbsp; */}
                            <span className={`xsTitle flex-space`}>
                              {el?.DocNo}
                            </span>
                            <span className={`desc`}>{`${formatDate(
                              el?.TransactionDate
                            )}`}</span>
                          </>
                        }
                        secondary={
                          <Grid
                            container
                            className="desc flex-space text-noflow"
                          >
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={9}>
                                <span style={{ fontSize: '11px' }}>
                                  {el?.DebtorName}
                                </span>
                              </Grid>
                              <Grid item xs={3}>
                                <IconText
                                  parentStyle={{ justifyContent: 'end' }}
                                  font="xxTitle c-orange"
                                  children={amtStr(el?.DocAmt)}
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12}>
                                <span style={{ fontSize: '10px' }}>
                                  {el?.Name}
                                </span>
                              </Grid>
                              {/* <Grid item xs={3}>
                                <IconText
                                  parentStyle={{ justifyContent: 'end' }}
                                  font="xxTitle c-orange"
                                  children={amtStr(el?.DocAmt)}
                                />
                              </Grid> */}
                            </Grid>

                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12}>
                                <div className="icon-text">
                                  <Tooltip
                                    disableFocusListener
                                    title={
                                      <Fragment>
                                        <Grid
                                          container
                                          wrap="nowrap"
                                          spacing={2}
                                        >
                                          <Grid item>
                                            <IconText
                                              icon={
                                                <img
                                                  src={SubmitterLog}
                                                  style={{
                                                    width: '12px',
                                                    marginRight: '3px',
                                                  }}
                                                />
                                              }
                                              font="desc"
                                            />
                                          </Grid>
                                          <Grid item xs zeroMinWidth>
                                            <div style={{ fontSize: '12px' }}>
                                              {
                                                userList?.find(
                                                  x => x?.ID === el?.IssuedBy
                                                )?.name
                                              }
                                            </div>
                                            <div style={{ fontSize: '10px' }}>
                                              {formatDate(el?.IssuedDate)}{' '}
                                              &nbsp;
                                              {formatTime(el?.IssuedDate)}
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Fragment>
                                    }
                                    arrow
                                    enterTouchDelay={0}
                                  >
                                    <div>
                                      <IconText
                                        icon={
                                          <img
                                            src={SubmitterLog}
                                            style={{
                                              width: '12px',
                                              marginRight: '3px',
                                            }}
                                          />
                                        }
                                        font="desc"
                                      />
                                    </div>
                                  </Tooltip>

                                  <span
                                    className="desc text-noflow"
                                    style={{ display: 'contents' }}
                                  >
                                    {el?.Description}
                                  </span>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          aria-label="arrow"
                          disabled={handlePermDisabled({
                            companyID: CompanyID,
                            permEnum:
                              AcctPermission.AccReceivableIssueProformaInvoiceView,
                          })}
                        >
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/proforma-invoices/issue-proforma-invoice/${el?.ProformaRequisitionID}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                }
              })}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      {listStatus === 'PENDING' ? (
        <AccountFooter
          options={[
            {
              name: 'Issue',
              onClick: () => {
                onSubmit(listPostIDs)
              },
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.AccReceivableIssueProformaInvoiceView,
                  })
                    ? true
                    : false,
              },
            },
          ]}
        />
      ) : null}

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  )
}
